import l from"../internals/export.js";import r from"../internals/global.js";var a=l,o=r;a({global:!0,forced:o.globalThis!==o},{globalThis:o});
